export default __webpack_public_path__ + "static/media/1825.5a4291c6.png";